import Suggestion, { SuggestionAction } from "./suggestion";
import React from "react";
import Trans from "atoms/i18n/trans";
import { t } from "utilities/localization-utils";

export interface AcceptedToolCallSuggestionProps {
    primaryAction: SuggestionAction;
    secondaryAction: SuggestionAction;
    route: string;
    routeText: string;
    isCurrentPage: boolean;
}
const BASE_CLASS = "c-suggestion";

const AcceptedToolCallSuggestion = ({
    primaryAction,
    secondaryAction,
    route,
    routeText,
    isCurrentPage,
}: AcceptedToolCallSuggestionProps) => {
    return (
        <Suggestion
            primaryAction={primaryAction}
            secondaryAction={secondaryAction}>
            {() => {
                return (
                    <div className={`${BASE_CLASS}__accepted`}>
                        {!isCurrentPage ? (
                            <Trans
                                i18nKey={"casi-checklist-created-with-routing"}
                                values={{ destination: routeText }}>
                                <span className={`${BASE_CLASS}`}>
                                    {`I created a new checklist ${routeText}`}
                                </span>

                                <a
                                    className={`${BASE_CLASS}__notebook-link`}
                                    href={`/${route}`}>
                                    {routeText}
                                </a>
                                <span>.</span>
                            </Trans>
                        ) : (
                            <div>{t("casi-checklist-created")}</div>
                        )}
                    </div>
                );
            }}
        </Suggestion>
    );
};

export default AcceptedToolCallSuggestion;
